import store from "../store";
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage"; // esto es para el storage
import router from "../routes";
import apiServices from "@/services/yungol-services";

const config = {
  apiKey: process.env.apiKey,
  authDomain: process.env.authDomain,
  databaseURL: process.env.databaseURL,
  projectId: process.env.projectId,
  storageBucket: process.env.storageBucket,
  messagingSenderId: process.env.messagingSenderId,
  appId: process.env.appId
};

export default {
  install: (Vue, options) => {
    firebase.initializeApp(config);
    const auth = firebase.auth();
    Vue.prototype.$auth = {
      login: async (username, pass) => {
        auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        return auth.signInWithEmailAndPassword(username, pass);
      },
      loginGoogle: async () => {
        const provider = new firebase.auth.GoogleAuthProvider();
        auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        return auth.signInWithPopup(provider);
      },
      logout: async () => {
        await auth.signOut();
        store.commit("restartStore");
      }
    };
    Vue.prototype.$fire = {
      putimg: file => {
        return firebase
          .storage()
          .ref(
            `images/${store.state.empresa._id}/${new Date().getTime()} - ${file.name
            }`
          )
          .put(file);
      },
      imgproduct: file => {
        return firebase
          .storage()
          .ref(
            `images/${store.state.empresa._id}/${new Date().getTime()} - ${file.name
            }`
          )
          .put(file);
      },
      logos: file => {
        return firebase
          .storage()
          .ref(
            `logos/${store.state.empresa._id}/${new Date().getTime()} - ${file.name
            }`
          )
          .put(file);
      },
      reffile: file => {
        return firebase
          .storage()
          .ref(
            `files/${store.state.empresa._id}/${new Date().getTime()} - ${file.name
            }`
          )
          .put(file);
      },
      refexcel: file => {
        return firebase
          .storage()
          .ref(
            `excel/${store.state.empresa._id}/${new Date().getTime()} - ${file.name
            }`
          )
          .put(file);
      },
      attachproject: file => {
        return firebase
          .storage()
          .ref(
            `attachproject/${store.state.empresa._id}/${new Date().getTime()} - ${file.name
            }`
          )
          .put(file);
      }
    };
    auth.onAuthStateChanged(user => {
      if (user) {
        localStorage.setItem("loggedin", "true");
        store.commit("refreshUser", user);
        store.commit("refreshAuth");
        user.getIdToken().then(
          idtoken => {
            store.commit("decodeToken", idtoken);
            if (
              store.state.tokenUser.admin ||
              store.state.tokenUser.contador ||
              store.state.tokenUser.auxiliar ||
              store.state.tokenUser.gerente ||
              store.state.tokenUser.vendedor ||
              store.state.tokenUser.proyectos ||
              store.state.tokenUser.task
            ) {
              store.commit("refreshAuth");
              apiServices
                .get(`/empresacredential`, {
                  headers: {
                    Authorization: "Bearer " + idtoken
                  }
                })
                .then(empresa => {
                  store.commit("refreshEmpresa", empresa.data);
                });
              apiServices
                .get(`/cuentas/reg`, {
                  headers: {
                    Authorization: "Bearer " + idtoken
                  }
                })
                .then(result => {
                  store.commit("refreshCuentas", result.data);
                });
              apiServices
                .get(`/nits`, {
                  headers: {
                    Authorization: "Bearer " + idtoken
                  }
                })
                .then(result => {
                  store.commit("refreshNits", result.data);
                });
              apiServices
                .get(`/productos`, {
                  headers: {
                    Authorization: "Bearer " + idtoken
                  }
                })
                .then(result => {
                  store.commit("refreshProductos", result.data);
                });
              apiServices
                .get(`/bodegas`, {
                  headers: {
                    Authorization: "Bearer " + idtoken
                  }
                })
                .then(result => {
                  store.commit("refreshBodegas", result.data);
                });
            } else {
              localStorage.removeItem("loggedin");
              store.commit("restartStore");
              router.replace({
                name: "logout"
              });
            }
          },
          error => {
            store.commit("restartStore");
            console.log(error);
          }
        );
      } else {
        localStorage.removeItem("loggedin");
        store.commit("restartStore");
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/firebase/index.js